import type { GetCurrentSessionQuery } from "@generated/graphql";
import { GET_CURRENT_SESSION_NO_UPDATE } from "clientState/operations/queries/getCurrentSession/getCurrentSession";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import type { UseGetCurrentSessionIfMeta } from "./contract";

export const useGetCurrentSessionIfMeta: UseGetCurrentSessionIfMeta = (
  isMeta: boolean,
) => {
  const { loading, data, errors } = useQuery<GetCurrentSessionQuery>(
    GET_CURRENT_SESSION_NO_UPDATE,
    {
      skip: !isMeta,
    },
  );

  return {
    loading,
    currentSession: data?.listLoginSessions.currentSession ?? null,
    errors,
  };
};
